import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Box, Grid, Table, TableRow, TableHead, TableBody, TableCell, TableContainer} from "@material-ui/core";

const ItemView = ({data, openHistory}) => {
  const [selectedImg, setSelectedImg] = useState(data?.type?.photo);

  useEffect(() => {
    setSelectedImg(data?.type?.photo);
  }, [data]);

  const baseUrl = `${process.env.REACT_APP_BASE_URL}/uploads/fridges-types`;

  return (
    <Grid container style={{minHeight: "200px"}}>
      {/* Left side: Images */}
      <Grid
        item
        xs={12}
        md={6}
        style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column"}}
      >
        <Box sx={{width: "100%", height: 250, textAlign: "center"}}>
          <img
            style={{width: "100%", height: "100%", objectFit: "contain"}}
            src={`${baseUrl}/${selectedImg}`}
            alt="asset"
          />
        </Box>

        <Box sx={{width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", mt: 1}}>
          {[data?.image1, data?.image2].map((img, idx) =>
            img ? (
              <img
                key={idx}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  cursor: "pointer",
                  padding: 5,
                  borderWidth: 2,
                  borderStyle: "solid",
                  borderColor: selectedImg === img ? "lightblue" : "lightgrey",
                  borderRadius: 10,
                  margin: 10,
                }}
                src={`${baseUrl}/${img}`}
                alt={`asset-${idx}`}
                onClick={() => setSelectedImg(img)}
              />
            ) : null
          )}
        </Box>
      </Grid>

      {/* Right side: Details and table */}
      <Grid item xs={12} md={6} style={{paddingLeft: 20}}>
        <Box sx={{width: "100%", minHeight: "100px", pt: 1}}>
          <p>
            <strong style={{textDecoration: "underline"}}>Name:</strong> {data?.type?.name}
          </p>
          <p>
            <strong style={{textDecoration: "underline"}}>Type:</strong> {data?.type?.refrigerant_type}
          </p>
          <p>
            <strong style={{textDecoration: "underline"}}>Refrigerant:</strong> {data?.type?.refrigerant_type}
          </p>
          <p>
            <strong style={{textDecoration: "underline"}}>Code:</strong> {data?.type?.code}
          </p>
          <p>
            <strong style={{textDecoration: "underline"}}>Dimensions (L×W×H):</strong> {data.length} ×{" "}
            {data?.type?.width} × {data?.type?.height} / CBM: {data.cbm}
          </p>
          <p>
            <strong style={{textDecoration: "underline"}}>Pieces:</strong> {data.cabinets?.length || 0}
          </p>
        </Box>

        <TableContainer style={{maxHeight: "30vh"}}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Serial #</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.details?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="left" style={{cursor: "pointer"}} onClick={() => openHistory(row.id)}>
                    {row.serial_number}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

ItemView.propTypes = {
  data: PropTypes.object.isRequired,
  openHistory: PropTypes.func.isRequired,
};

export default ItemView;
